import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { Circuit } from 'features/home/types'
import { Cell } from 'react-table'
import { getGlyph } from './loadIcon'
import { LoadCellWrapper, LoadSpan, OnState } from './styles'
import { formatPower } from '../utils'
import { messages } from '../messages'

export const LoadCell = (cell: Cell<Circuit>) => {
  const glyph = useMemo(() => getGlyph(cell?.row?.original?.image), [cell])

  return (
    <LoadCellWrapper>
      {glyph} <LoadSpan>{cell?.value}</LoadSpan>
    </LoadCellWrapper>
  )
}

export const PowerCell = (cell: Cell<Circuit>) => {
  return formatPower(cell?.value)
}

export const StateCell = (cell: Cell<Circuit>) => {
  const { formatMessage } = useIntl()
  if (cell?.value === -1) {
    return '-'
  }
  return cell?.value === 1 ? (
    <OnState>{formatMessage(messages.stateOn)}</OnState>
  ) : (
    formatMessage(messages.stateOff)
  )
}
